var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGws(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 264.8 227.2",
    style: {
      enableBackground: "new 0 0 264.8 227.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F47920;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.8,75.9l-3.4,4.7c-1.9,2.7-5,4.3-8.3,4.3H86.6l15.8-22.1c1.9-2.6,5-4.2,8.2-4.2h72.2l42-58.7H116.4 C74.6,0,40.7,33.9,40.7,75.7c0,41.8,33.9,75.7,75.7,75.7l54.1-75.6L128.8,75.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.8,202.7c0-5.7-3.1-8.2-8.3-9.6c-12.2-3.4-17.5-4.9-18.4-5.2c-0.6-0.2-1-0.5-1-1.2v-8 c0-0.6,0.4-0.9,0.9-0.9h12.4c0.6,0,0.9,0.4,0.9,0.9v5.2h13.2v-8.2c0-5.6-4.5-10.2-10.2-10.2h-20.4c-5.7,0-10.2,4.5-10.2,10.2v13.8 c0,5.6,3.2,8.1,8.6,9.6c11.5,3.2,16.4,4.6,18,5.1c0.7,0.2,1.2,0.5,1.2,1.2v8.6c0,0.6-0.4,0.9-0.9,0.9h-13c-0.6,0-0.9-0.4-0.9-0.9 v-5.3h-13.2v8.2c0,5.7,4.5,10.2,10.2,10.2h20.9c5.7,0,10.2-4.5,10.2-10.2V202.7z M174.8,177.7h15.9v49.5h13.4v-49.5h15.9v-12.2 h-45.3V177.7z M170.1,165.5h-13v36.1l-20.6-36.1h-13v61.7h13v-36l20.6,36h13V165.5z M93.1,182.6l5.6,20.6H87.6L93.1,182.6z  M99.9,165.5H86.4l-20.2,61.7h13.7l3.7-12.2h19l3.9,12.2h13.7L99.9,165.5z M62.8,165.5H49.3v61.7h13.4V165.5z M20.3,205.3H29v8.8 c0,0.6-0.4,0.9-0.9,0.9H14.4c-0.6,0-0.9-0.4-0.9-0.9v-35.4c0-0.6,0.4-0.9,0.9-0.9H28c0.6,0,0.9,0.4,0.9,0.9v6.3h13.2v-9.3 c0-5.6-4.5-10.2-10.2-10.2H10.2c-5.6,0-10.2,4.5-10.2,10.2V217c0,5.7,4.5,10.2,10.2,10.2H32c5.7,0,10.2-4.5,10.2-10.2v-23.4H20.3 V205.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGws);
export default __webpack_public_path__ + "static/media/gws.44387342b3c427847b88b7c3777a10ce.svg";
export { ForwardRef as ReactComponent };